export default __webpack_public_path__ + "static/human-10cbaaed9269ceeb8ae2522a01594633.png";